var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5848:33375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5848:33375)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#38CB89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5848:33375",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5848:33375",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5848:33375",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.82032635.svg";
export { ForwardRef as ReactComponent };